import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { toast } from 'bulma-toast';
import firebase from 'firebase/app';
import { CookieService } from '@shared/service/cookie/cookie.service';
import { environment } from '@env';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  passwordHide = true;
  progressing = false;
  passwordForgotMessage = false;
  spiralPasswordReminderUrl = environment.spiralPassword;
  errMessageList = [];

  constructor(
    private afFunc: AngularFireFunctions,
    private cookieService: CookieService,
    public auth: AngularFireAuth,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.progressing = false;
    this.auth.onAuthStateChanged((user: firebase.User) => {
      if (!user) {
        console.log(`user ${user}`);
        return;
      }
      user.getIdTokenResult().then((idToken: firebase.auth.IdTokenResult) => {
        console.log(idToken);
        const isAdmin = idToken.claims.fadmin;
        if (isAdmin) {
          this.router.navigateByUrl('/fadmin/top');
        } else {
          this.router.navigateByUrl('/staff/top');
        }
      });
    });
  }

  login(): void {
    this.clearError();
    this.progressing = true;
    this.afFunc
      .httpsCallable('loginWithSpiral')({
        mail: this.username,
        password: this.password,
      })
      .subscribe((res: any) => {
        if (res.err != '') {
          this.progressing = false;
          this.errMessageList = this.authErrorMessage(res.err);
        }
        this.cookieService.setDCMemberStatusCookie(res.data.dcMemberStatus);
        this.auth
          .signInWithCustomToken(res.data.token)
          .then(() => {
            if (res.data.isAdmin) {
              this.router.navigateByUrl('/fadmin/top');
            } else {
              this.router.navigateByUrl('/staff/top');
            }
          })
          .catch((reason) => {
            this.progressing = false;
            this.errMessageList = this.authErrorMessage(res.err);
          });
      });
  }

  logout(): void {
    this.cookieService.deleteDCMemberStatusCookie();
    this.auth.signOut();
  }

  loginAvaival(): boolean {
    return this.username != '' && this.password != '';
  }

  private authErrorMessage(reason: any): string[] {
    const errorCode = reason;
    switch (errorCode) {
      case 'Invalid identification information':
        return ['メールアドレス、またはパスワードが正しくありません。'];
      case 'Login locked':
        this.passwordForgotMessage = true;
        return ['ログインに5回連続で失敗したため、30分間ログインできません。'];
      default:
        return [
          'ログインに失敗しました。',
          'グループへのご参加状況や、メールアドレス・パスワードをご確認のうえ、再度ログイン操作を行ってください。',
        ];
    }
  }

  onClickPasswordHide(): void {
    this.passwordHide = !this.passwordHide;
  }
  onClickClearError(): void {
    this.clearError();
  }
  clearError(): void {
    this.errMessageList = [];
    this.passwordForgotMessage = false;
  }
}
